


















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { orderBy } from "lodash";
import DataPenunjang from "@/services/DataPenunjang";
import HasilLabSampel from "@/components/pemeriksaan/penunjang/HasilLabSampel.vue";

interface TesLab {
  test_id: string;
  nama_test: string;
  hasil: string;
  satuan: string;
  nilai_normal: string;
  flag: string;
}

interface SampelLab {
  lis_sampel: string;
  tgl_order: string;
  acc_date: string;
  acc_by: string;
  unit_nama: string;
  dokter: string | null;
  jenis_label: string;
  catatan: string | null;
  items: TesLab[] | null;
}

interface UnitRo {
  id: string;
  nama: string | null;
}

interface TransaksiRo {
  no_transaksi: string;
  tgl: string;
  dr_radiologi: string;
  unit: UnitRo | null;
  unit_asal: UnitRo | null;
  item: { kode: string; nama: string }[] | null;
}

interface ItemRo {
  kode: string;
  nama: string;
  no_transaksi: string;
  tgl: string;
}

interface HasilRo {
  acc_number: string;
  description: string;
  reportDate: string;
  dokter: string;
  link: string;
}

interface StatusHasilRo {
  status: "memuat" | "ada" | "kosong";
  data: HasilRo | null;
}

interface GrupRiwayat {
  kunci: string;
  asal: string;
  tanggal: string;
  urutan: string;
  dokter: string;
  pemeriksaan: string;
  abnormal: string;
  sampel: SampelLab[];
  itemRo: ItemRo[];
  dokterList: string[];
}

@Component({
  components: {
    HasilLabSampel
  }
})
export default class CardRiwayatHasilRingkas extends Vue {
  @Prop() readonly type!: string;
  @Prop() readonly rm!: string;

  sampelLab: SampelLab[] = [];
  transaksiRoMentah: TransaksiRo[] = [];
  memuat = false;
  nomorPermintaan = 0;
  panel: number | null = null;
  hasilRo: Record<string, StatusHasilRo> = {};
  popupTerbuka = false;
  grupPopup: GrupRiwayat | null = null;

  created() {
    this.muat();
  }

  get daftar(): GrupRiwayat[] {
    const grup: Record<string, GrupRiwayat> = {};
    const tambah = (asal: string, tgl: string, dokter: string | null) => {
      const kunci = `${asal}|${tgl}`;
      if (!grup[kunci]) {
        grup[kunci] = {
          kunci,
          asal,
          tanggal: this.formatTanggal(tgl),
          urutan: tgl,
          dokter: "",
          pemeriksaan: "",
          abnormal: "",
          sampel: [],
          itemRo: [],
          dokterList: []
        };
      }
      if (dokter) grup[kunci].dokterList.push(dokter.trim());
      return grup[kunci];
    };

    if (this.type == "lab") {
      this.sampelLab.forEach(sampel => {
        const tgl = this.tanggalSaja(sampel.acc_date || sampel.tgl_order);
        tambah(this.asalLab(sampel), tgl, sampel.dokter).sampel.push(sampel);
      });
    } else {
      this.transaksiRoMentah.forEach(transaksi => {
        const g = tambah(
          this.asalRo(transaksi),
          this.tanggalSaja(transaksi.tgl),
          transaksi.dr_radiologi
        );
        (transaksi.item || []).forEach(item => {
          g.itemRo.push({
            kode: item.kode,
            nama: item.nama,
            no_transaksi: transaksi.no_transaksi,
            tgl: transaksi.tgl
          });
        });
      });
    }

    const hasil = Object.keys(grup).map(kunci => {
      const g = grup[kunci];
      const tes = g.sampel.reduce(
        (semua: TesLab[], sampel) => semua.concat(sampel.items || []),
        []
      );
      g.dokter = this.gabungUnik(g.dokterList);
      g.pemeriksaan =
        this.type == "lab"
          ? this.gabungUnik(tes.map(t => t.nama_test))
          : this.gabungUnik(g.itemRo.map(i => i.nama));
      g.abnormal = tes
        .filter(t => this.isAbnormal(t.flag))
        .map(t => `${t.nama_test} ${t.hasil} (${t.flag})`)
        .join(", ");
      return g;
    });
    return orderBy(hasil, ["urutan"], ["desc"]);
  }

  get jumlah(): number | null {
    return this.memuat ? null : this.daftar.length;
  }

  @Watch("jumlah", { immediate: true })
  changeJumlah(val: number | null) {
    this.$emit("jumlah", val);
  }

  @Watch("daftar")
  changeDaftar() {
    this.panel = null;
  }

  @Watch("panel")
  changePanel() {
    this.muatHasilGrupTerbuka();
  }

  @Watch("popupTerbuka")
  changePopupTerbuka(val: boolean) {
    if (!val) this.grupPopup = null;
  }

  bukaPopup(grup: GrupRiwayat) {
    this.grupPopup = grup;
    this.popupTerbuka = true;
  }

  @Watch("rm")
  changeRm() {
    this.sampelLab = [];
    this.transaksiRoMentah = [];
    this.hasilRo = {};
    this.muat();
  }

  muat() {
    if (!this.rm) return;
    const nomor = ++this.nomorPermintaan;
    this.memuat = true;
    const permintaan =
      this.type == "lab"
        ? DataPenunjang.getDataRiwayatLab(this.rm)
        : DataPenunjang.getDataListHasilRoByRm(this.rm);
    permintaan
      .then((res: { data?: SampelLab[] | TransaksiRo[] }) => {
        if (nomor !== this.nomorPermintaan) return;
        const data = res && Array.isArray(res.data) ? res.data : [];
        if (this.type == "lab") {
          this.sampelLab = data as SampelLab[];
        } else {
          this.transaksiRoMentah = data as TransaksiRo[];
        }
      })
      .finally(() => {
        if (nomor === this.nomorPermintaan) this.memuat = false;
      });
  }

  muatHasilGrupTerbuka() {
    if (this.type != "ro" || this.panel === null) return;
    const grup = this.daftar[this.panel];
    if (!grup) return;
    grup.itemRo.forEach(item => {
      const kunci = this.kunciHasilRo(item);
      if (this.hasilRo[kunci]) return;
      this.$set(this.hasilRo, kunci, { status: "memuat", data: null });
      DataPenunjang.getDataDetailHasilRo(
        item.no_transaksi,
        item.tgl,
        item.kode
      ).then((res: { data?: HasilRo }) => {
        const data = res && res.data;
        this.$set(
          this.hasilRo,
          kunci,
          data && data.acc_number
            ? { status: "ada", data }
            : { status: "kosong", data: null }
        );
      });
    });
  }

  kunciHasilRo(item: ItemRo): string {
    return `${item.no_transaksi}|${item.tgl}|${item.kode}`;
  }

  statusHasilRo(item: ItemRo): string {
    const hasil = this.hasilRo[this.kunciHasilRo(item)];
    return hasil ? hasil.status : "memuat";
  }

  dataHasilRo(item: ItemRo): HasilRo | Record<string, string> {
    const hasil = this.hasilRo[this.kunciHasilRo(item)];
    return (hasil && hasil.data) || {};
  }

  asalLab(sampel: SampelLab): string {
    const jenis = (sampel.jenis_label || "").trim();
    const unit = (sampel.unit_nama || "").trim();
    if (jenis && unit && jenis.toLowerCase() != unit.toLowerCase()) {
      return `${jenis} / ${unit}`;
    }
    return unit || jenis || "-";
  }

  asalRo(transaksi: TransaksiRo): string {
    const asal = transaksi.unit_asal && transaksi.unit_asal.nama;
    const unit = transaksi.unit && transaksi.unit.nama;
    return ((asal || unit || "") as string).trim() || "-";
  }

  gabungUnik(nama: string[]): string {
    return nama
      .filter(n => !!n)
      .filter((n, i, semua) => semua.indexOf(n) === i)
      .join(", ");
  }

  isAbnormal(flag: string | null): boolean {
    const nilai = (flag || "").trim();
    return nilai !== "" && nilai !== "*";
  }

  tanggalSaja(val: string): string {
    return val ? String(val).substring(0, 10) : "";
  }

  formatTanggal(val: string): string {
    if (!val) return "-";
    const m = moment(val, "YYYY-MM-DD");
    return m.isValid() ? m.format("DD MMM YYYY") : val;
  }
}
